import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { TagSchemas } from "../ea.schema";
import { CountResponseSchema } from "../ea.schema.endpoints";
import { GetRequestBaseResponseSchema, TagFilterSchema } from "../ea.schema.query";

const base = "tags";
const tags = createEndpointBase(base);

export const tagsEndpoints = {
  tagsGet: tags({
    method: "GET",
    path: "",
    request: z.object({ filter: TagFilterSchema.optional() }).optional(),
    response: GetRequestBaseResponseSchema(TagSchemas["general"]),
    description: "Retrieves a list of tags with filtering support.",
  }),
  tagsCount: tags({
    method: "GET",
    path: "count",
    request: z.any(),
    response: CountResponseSchema,
    description: "Returns the total number of tags matching the filters.",
  }),
  tagsCreate: tags({
    method: "POST",
    path: "",
    request: TagSchemas["createData"],
    response: TagSchemas["general"],
    description: "Creates a new tag.",
  }),
  tagsUpdate: tags({
    method: "PATCH",
    path: ":id",
    request: TagSchemas["update"],
    response: TagSchemas["general"],
    description: "Updates an existing tag.",
  }),
  tagsDelete: tags({
    method: "DELETE",
    path: ":id",
    request: z.any(),
    response: z.any(),
    description: "Permanently deletes a tag.",
  }),
} as const;
